export const environments = {
  DEV: 'development',
  STAGE: 'stage',
  PROD: 'production',
};

export const env = {
  environment: process.env.REACT_APP_ENVIRONMENT || environments.DEV,
  API_URL: process.env.REACT_APP_API_URL || '',
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL || '',
  GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
};
